module.exports = __webpack_public_path__ + "img/Group 97872.bb900a24.png";